var _path, _circle, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWcst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16L33.8 26.8H45L35.6 33.2L39.4 44L30 37.6L20.6 44L24.4 33.2L15 26.8H26.2Z",
    fill: "#C75E5A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 30,
    r: 14,
    fill: "#F9907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56L44 84H16Z",
    fill: "#FE8470"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 58,
    width: 14,
    height: 28,
    rx: 2,
    fill: "#FAC1B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 65,
    width: 28,
    height: 14,
    rx: 2,
    fill: "#FAC1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcst);
export default __webpack_public_path__ + "static/media/WCST.1b964a47f412ff1383fe10046eca6abf.svg";
export { ForwardRef as ReactComponent };